/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Remove_Line_All_UppercaseInputs */



/**
* | output |
* | --- |
* | "Remove line if it's all uppercase" |
*
* @param {Remove_Line_All_UppercaseInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const remove_line_all_uppercase = /** @type {((inputs?: Remove_Line_All_UppercaseInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Remove_Line_All_UppercaseInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Supprimer la ligne si elle est en majuscules")
	if (locale === "de") return /** @type {LocalizedString} */ ("Zeile entfernen, falls sie nur aus Großbuchstaben besteht")
	if (locale === "it") return /** @type {LocalizedString} */ ("Rimuovi la riga se è tutta in maiuscolo")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Удалите строку, если все буквы заглавные.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Eliminar línea si está toda en mayúsculas")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("如果全是大写字母，则删除该行。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("すべて大文字の場合は行を削除します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("यदि पंक्ति पूरी तरह से बड़े अक्षरों में है तो उसे हटा दें।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Remova a linha se estiver tudo em maiúsculas.")
	return /** @type {LocalizedString} */ ("Remove line if it's all uppercase")
});